@if (showModule) {
    <div class="showcase-header" [ngClass]="collapse ? 'collapse' : 'expand'" (click)="toggle()">
        <div class="header-title" [class.full-width]="!liveAlertManager.queuedAlerts.length && !liveAlertManager.alerts.length">
            {{ title }}
        </div>
        @if (collapse) {
            <span class="arrow">
                <vn-icon name="theme-down" size="12" />
            </span>
        } @else {
            <ms-live-alert-list />
        }
    </div>

    @if (!collapse && selectedEvent()) {
        @let evt = selectedEvent()!;
        @if (moduleData.events.length > 1) {
            <div class="showcase-subheader">
                <ms-showcase-tab-bar [events]="moduleData.events" [scrollEnabled]="true" [selectedEventId]="evt.id" />
            </div>
        }
        <div class="showcase-content-container" [style.background-image]="bgImage">
            <div class="showcase-content-container-overlay">
                <div class="showcase-scoreboard-market">
                    <div class="showcase-scoreboard-container" [ngClass]="getClass(tabContainerClasses, feature()?.id)">
                        <div class="league-title-media">
                            <div class="league-title-logo">
                                <span class="league-logo">
                                    @if (showCompetitionLogo) {
                                        <ms-competition-logo
                                            [sportId]="evt.sport.id"
                                            [leagueId]="evt.league.id"
                                            [imageProfile]="evt.league.imageProfile" />
                                    } @else {
                                        <span class="icon">
                                            <vn-icon name="sports-{{ evt.sport.id }}" [size]="epcotEnabled ? '16' : '12'" />
                                        </span>
                                    }
                                </span>
                                <span class="league-name"> {{ evt.league.name }} </span>
                            </div>
                            <ms-showcase-media [showHeaderContent]="showHeaderContent" [tabSelectedEvent]="mediaEvent" />
                        </div>
                        <div
                            class="scoreboard-background"
                            [ngStyle]="scoreboardBgColor()"
                            [ngClass]="getClass(tabContainerBackgroundClasses, feature()?.id)">
                            @if (showHeaderContent) {
                                <ms-header-content
                                    [event]="mediaEvent"
                                    [feature]="feature()"
                                    [isShowcase]="true"
                                    (click)="goToEvent(evt)"
                                    (toggle)="densityToggled($event)" />
                            } @else {
                                <ms-scoreboard
                                    [isShowcase]="true"
                                    [event]="evt"
                                    [size]="evt.scoreboard && evt.scoreboard.started ? sizeDensity.Medium : sizeDensity.Small"
                                    [hideTimer]="false"
                                    (click)="goToEvent(evt)" />
                            }
                        </div>
                    </div>
                    @if (evt.optionGroups.length) {
                        <div class="showcase-market-container">
                            <ms-option-group-container
                                [gridGroup]="gridGroup"
                                [event]="evt"
                                [tracking]="{ source: tracking, position: selectedEventPosition }"
                                [groupingConfig]="groupingConfig" />
                        </div>
                    }
                </div>
                @if (moduleData.showSpecialContents && ((tiles$ | async)?.length || crmBannerPromotions.length)) {
                    <div class="showcase-promotion-container">
                        @if ((tiles$ | async)?.length) {
                            <ng-container *msComponentProxy="marqueeComponent" />
                        } @else {
                            <ms-crm-promotion-container [promotions]="crmBannerPromotions" [trackingSource]="TrackingSource.ShowCase" />
                        }
                    </div>
                }
            </div>
        </div>
    }
}
